type Theme = 'day' | 'night';
export const readTheme = (): Theme => {
  const current = localStorage.getItem('theme') as Theme;
  return current ?? 'night';
};

export const writeTheme = (theme: Theme): void => {
  localStorage.setItem('theme', theme);
};
